/**
 * Created by pandemio on 4/12/19.
 */
import React from 'react';

/**
 * Generic component for pie charts
 */
class PieChart extends React.Component {

    constructor(props){
        // Super is always called when definiting the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.data = this.props.chartData;
    }

    /**
     * This handles every time we update the chart
     * @param props
     */
    componentWillReceiveProps(props){
        this.data =  props.chartData;
    }

    /**
     * Renders the component
     * @returns {XML}
     */
    render(){
        // Specify the chart you want to try
        let PieChart = require("react-chartjs").Pie;

        // The options
        let options = {
            segmentShowStroke : true,

            //String - The colour of each segment stroke
            segmentStrokeColor : "#fff",

            //Number - The width of each segment stroke
            segmentStrokeWidth : 2,

            //Number - The percentage of the chart that we cut out of the middle
            percentageInnerCutout : 0, // This is 0 for Pie charts

            //Number - Amount of animation steps
            animationSteps : 100,

            //String - Animation easing effect
            animationEasing : "easeOutSine",

            //Boolean - Whether we animate the rotation of the Doughnut
            animateRotate : true,

            //Boolean - Whether responsive or not
            responsive: true
        };

        return (
            <PieChart redraw data={this.data} options={options} width="600" height="250"/>
        );
    }
}
export default PieChart;